import { fetchHealthEnrollmentStatus } from 'platform/shared/health-apps';
import { isLOA3 } from 'platform/user/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTotalDisabilityRating } from '../actions';

export const useLoa3UserData = () => {
  const isUserLOA3 = useSelector(isLOA3);
  const dispatch = useDispatch();

  const getDisabilityRating = () => dispatch(fetchTotalDisabilityRating());
  const getEnrollmentStatus = () => dispatch(fetchHealthEnrollmentStatus());

  useEffect(
    () => {
      if (isUserLOA3) {
        getDisabilityRating();
        getEnrollmentStatus();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isUserLOA3],
  );
};
